import React, {FC, useCallback} from 'react'
import {DrawerComponents} from '../../components'
import {useQuery} from 'react-query'
import {Get} from '../../../../../setup'
import {TemplateCardInterface, TemplatesCollection} from '../../components/types'
import {
  localStorageTemplateSelectedType,
} from '../../../../../app/features'
import {useStorage} from '../../../../../app/@contexts'

const ALL_TEMPLATES = process.env.REACT_APP_MAILING_ALL_TEMPLATES || 'v2/templates'
const APP_URL = process.env.REACT_APP_URL || 'https://mywebforce.webforce.be'

const DrawerTemplates: FC = () => {
  const {data} = useQuery(
    'ALL_TEMPLATES',
    () => Get<TemplatesCollection>({endpoint: ALL_TEMPLATES}),
  )

  return (
    <DrawerComponents id="templates" title="Hello" width={{md: 700, lg: 900, xl: 1000}}>
      <div className="row">
        {data?.templatesDefault.map((item, index) => (
          <TemplateCard key={index} item={item} category={'d'} />
        ))}
      </div>
      <div className="row">
        {data?.templatesCreate.map((item, index) => (
          <TemplateCard key={index} item={item} category={'p'} />
        ))}
      </div>
    </DrawerComponents>
  )
}

export {DrawerTemplates}

const TemplateCard: FC<TemplateCardInterface> = ({item, category}) => {

  const {setMailing} = useStorage()

  const handleStorage = useCallback(async ({template}: localStorageTemplateSelectedType) => {
    setMailing({campaign: {template}})
    // await SetStorage<localStorageTemplateSelectedType>(LOCAL_STORAGE_TEMPLATE_SELECTED, {template})
  }, [setMailing])

  return (
    <div className={`col-12 col-md-4 col-lg-3 mb-3 ${item.image === null ? 'h-200px' : ''}`}>
      <div
        className="card card-custom overlay overflow-hidden position-relative border border-1 border-gray-200 rounded h-200px">
        <div className="card-body p-0">
          <div className="overlay-wrapper">
            {item.image !== null ? (
              <img src={`${APP_URL}/${item.image}`} className="w-100 rounded" alt={item.name} />
            ) : (
              <div style={{transform: 'scale(0.5)', transformOrigin: '0 0'}}>
                <div dangerouslySetInnerHTML={{__html: item.content}} />
              </div>
            )}
          </div>
          <div className="overlay-layer bg-dark bg-opacity-10">
            <div className="btn btn-sm btn-primary shadow"
                 id={`kt_drawer_templates_close`}
                 onClick={() => handleStorage({
                   template: {id: `${item.id}-${category}`, name: item.name, content: item.content},
                 })}
            >
              {item.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}